import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

export const getCustomAssetTooltipInfo = (
    industryId: string,
    industryName: string,
): { items: string[]; tmpSingleTitle: string } => {
    const customAndSharedIndustry = UserCustomCategoryService.getCustomAndSharedCategoryById(industryId);
    const tmpSingleTitle = customAndSharedIndustry
        ? customAndSharedIndustry.name || customAndSharedIndustry.text
        : industryName;

    return {
        items: customAndSharedIndustry ? customAndSharedIndustry.domains : [],
        tmpSingleTitle,
    };
};
